import React, { useCallback, useEffect, useState } from 'react';
import Layout from '../../layout/Layout';
import { Dropdown, Form, InputGroup, OverlayTrigger, Table, Tooltip } from 'react-bootstrap';
import CustomPagination from '../../components/CustomPagination';
import { useGlobalState } from '../../context/GlobalStateContext';
import NoDateFound from '../../components/NoDateFound';
import Loader from '../../components/loader/Loader';
import axiosInstance from '../../utils/axiosConfig';
import * as CustomToast from '../../components/CustomToastMessage';


function WebsiteEnquiry() {
    const [websiteList, setWebsiteList] = useState([])
    const [uniqueLinks, setUniqueLinks] = useState([])
    const { loading, setLoading, search, pagination, setPagination, handleSearch, handleLimitChange } = useGlobalState()

    const fetchWebsiteList = useCallback(async (page = 1, limit = 10, searchQuery = '', linkFilter = '') => {
        try {
            setLoading(true);
            const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/contact/request/list`, {
                params: {
                    page,
                    limit,
                    search: searchQuery,
                    link: linkFilter
                }
            });
            if (response.data.success) {
                setWebsiteList(response.data.data);
                setPagination(response.data.pagination);

                // Extract unique links
                const links = response.data.data.map(item => item.link).filter(link => link);
                const uniqueLinksSet = new Set(links);
                setUniqueLinks(["All", ...Array.from(uniqueLinksSet)]);
            } else {
                setWebsiteList([]);
                setPagination(prev => ({
                    ...prev,
                    currentPage: 1,
                    totalPages: 1,
                    totalItems: 0
                }));
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
            setWebsiteList([]);
            setPagination(prev => ({
                ...prev,
                currentPage: 1,
                totalPages: 1,
                totalItems: 0
            }));
        }
        finally {
            setLoading(false);
        }
    }, [setLoading, setPagination])
    useEffect(() => {
        fetchWebsiteList(pagination.currentPage, pagination.limit, search);
    }, [pagination.currentPage, pagination.limit, search, fetchWebsiteList]);

    // State for dropdown selection
    const [selectedLink, setSelectedLink] = useState("All");
    const [showDropdown, setShowDropdown] = useState(false);

    const handleSelect = (link) => {
        setSelectedLink(link);
        setShowDropdown(false);
        fetchWebsiteList(1, pagination.limit, search, link === "All" ? "" : link);
    };

    return (
        <Layout title="Website Enquiry List">
            <main>
                <div className="card page-card">
                    <div className="card-header d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                        <div className='d-flex align-items-center gap-3'>
                            <p>Show</p>
                            <Form.Select
                                aria-label="Default select example"
                                value={pagination.limit}
                                onChange={handleLimitChange}
                            >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                            </Form.Select>
                            <p>entries</p>
                        </div>

                        <div className='d-flex flex-column flex-md-row  align-items-start align-items-md-center gap-3'>
                            <Dropdown className="categories-dropdown" align="end" show={showDropdown} onToggle={(isOpen) => setShowDropdown(isOpen)}>
                                <Dropdown.Toggle as="div" id="dropdown-basic">
                                    <button className="d-flex align-items-center gap-3 categories_btn" onClick={() => setShowDropdown(!showDropdown)}>
                                        <img src="/images/png/categories.png" className="arrow" width={15} alt="" />
                                        <h6>{selectedLink}</h6>
                                        <img src="/images/png/arrow_2.png" className="arrow" width={15} alt="" />
                                    </button>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                    {uniqueLinks.map((link) => (
                                        <Dropdown.Item key={link} eventKey={link} active={selectedLink === link} onClick={() => handleSelect(link)}>
                                            {link}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                            <div className='header-search'>
                                <InputGroup>
                                    <InputGroup.Text id="basic-addon1" className='bg-transparent'>
                                        <img src="/images/png/search.png" width={20} alt="" />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="search"
                                        className='border-start-0 ps-0'
                                        placeholder="search here..."
                                        value={search}
                                        onChange={handleSearch(fetchWebsiteList)}
                                    />
                                </InputGroup>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="overflow-auto">
                            <Table hover className='vertical-align'>
                                <thead>
                                    <tr>
                                        <th>No.</th>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Email</th>
                                        <th>Phone Number</th>
                                        <th>Enquiry Date</th>
                                        <th>Message</th>
                                        <th>Website</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="9" className="text-center">
                                                <Loader />
                                            </td>
                                        </tr>
                                    ) : websiteList.length > 0 ? (
                                        websiteList.map((website, index) => (
                                            <tr key={website._id}>
                                                <td width="40px"><p className='mb-0'>{(pagination.currentPage - 1) * pagination.limit + index + 1}</p></td>
                                                <td>{website.firstName ? website.firstName : "-"}</td>
                                                <td>{website.lastName ? website.lastName : "-"}</td>
                                                <td>{website.email ? website.email : "-"}</td>
                                                <td>{website.contactNo ? website.contactNo : "-"}</td>
                                                <td>{website.createdAt ? new Date(website.createdAt).toLocaleString().split("T")[0] : "-"}</td>
                                                <td>
                                                    <OverlayTrigger
                                                        placement="top"
                                                        overlay={<Tooltip id={`message-tooltip-${website._id}`}>{website.message ? website.message : "-"}</Tooltip>}
                                                    >
                                                        <div className='text-truncate table-td-200'>{website.message ? website.message : "-"}</div>
                                                    </OverlayTrigger>
                                                </td>
                                                <td>{website.link ? website.link : "-"}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" className="text-center">
                                                <NoDateFound />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                        <CustomPagination
                            currentPage={pagination.currentPage}
                            totalPages={pagination.totalPages}
                            totalItems={pagination.totalItems}
                            limit={pagination.limit}
                            onPageChange={(page) => setPagination(prev => ({ ...prev, currentPage: page }))}
                        />
                    </div>
                </div>
            </main>
        </Layout>
    )
}

export default WebsiteEnquiry;
